import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyTimeSlots = ({ onSelectDifferentDate }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 bg-muted rounded-full flex items-center justify-center mb-4 md:mb-6">
        <Icon name="CalendarX" size={40} color="var(--color-muted-foreground)" />
      </div>
      
      <h3 className="font-heading font-semibold text-xl md:text-2xl lg:text-3xl text-foreground mb-2 md:mb-3 text-center">
        No Available Slots
      </h3>
      
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground text-center max-w-md mb-6 md:mb-8">
        Unfortunately, there are no available time slots for the selected date. Please choose a different date to see available appointments.
      </p>
      
      <Button 
        variant="default" 
        iconName="Calendar" 
        iconPosition="left"
        onClick={onSelectDifferentDate}
      >
        Select Different Date
      </Button>
    </div>
  );
};

export default EmptyTimeSlots;